import * as React from 'react'

function SvgWalletFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      color="#00D37E"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 8H6.5a1.5 1.5 0 110-3h16a1.5 1.5 0 000-3h-16A4.5 4.5 0 002 6.5V26a2 2 0 002 2h22a2 2 0 002-2v-6h-9a2 2 0 01-2-2v-4a2 2 0 012-2h9v-2a2 2 0 00-2-2zm-5 10a2 2 0 100-4 2 2 0 000 4z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWalletFilled
